module.exports = __webpack_public_path__ + "static/media/3.เอกสารบันทึกถ้อยคำ.e395df57.pdf";